import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SignOut from "./../auth/SignOut";
import TalaeraDefaultBackground from "./../TalaeraDefaultBackground/TalaeraDefaultBackground";
import PrivateRoute from "./PrivateRoute";
import TalaeraRoutes from "./TalaeraRoutes";
import { ErrorBoundary } from "components/ErrorBoundary";
import UnauthRoutes from "./UnauthRoutes";
import PreserveQueryRedirect from "components/RedirectWithQueryParams/RedirectWithQueryParams";

const AsyncContentFolder = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentFolderPage" */
      "./../../pages/content/ContentFolderPage"
    )
);

const AsyncEditContentFile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EditContentFilePage" */
      "./../../pages/content/EditContentFilePage"
    )
);

const AsyncLibrary = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryPage" */
      "./../../pages/Library/LibraryPage"
    )
);

const AsyncLibraryRoot = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LibraryRootPage" */
      "../../pages/Library/LibraryRootPage"
    )
);

const AsyncCoursePage = React.lazy(() => import("./../../pages/Course/CoursePage"));

const AsyncAdminDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminDashboardPage" */
      "./../../pages/admin/AdminDashboard/AdminDashboardPage"
    )
);

const AsyncAdminTag = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdminTagPage" */
      "./../../pages/admin/AdminTag/AdminTagPage"
    )
);

export default class ContentAdminRoutes extends Component {
  render() {
    return (
      <ErrorBoundary pathname={this.props.location?.pathname}>
        <Routes key={this.props.location.pathname}>
          <Route
            path={TalaeraRoutes.ROOT.path}
            element={<Navigate to={TalaeraRoutes.ADMIN_CONTENT_FOLDER.path} replace />}
          />

          <Route
            path={TalaeraRoutes.ROOT.path}
            element={
              <PrivateRoute
                path={TalaeraRoutes.LIBRARY_ROOT.path}
                component={AsyncLibraryRoot}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          <Route
            path={TalaeraRoutes.LIBRARY_OBJECT.path}
            element={
              <PrivateRoute
                component={AsyncLibrary}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.COURSE_OBJECT.path}
            element={
              <PrivateRoute
                component={AsyncCoursePage}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_CONTENT_FOLDER.path}
            element={
              <PrivateRoute
                component={AsyncContentFolder}
                permissions="admin"
                smallWindow={this.props.smallWindow}
              />
            }
          />

          {/* TODO: Remove this route */}
          <Route
            path={TalaeraRoutes.ADMIN_CREATE_CONTENT_FILE.path}
            element={
              <PreserveQueryRedirect to={TalaeraRoutes.ADMIN_EDIT_CONTENT_FILE.path} />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_EDIT_CONTENT_FILE.path}
            element={
              <PrivateRoute
                component={AsyncEditContentFile}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_TAG_DETAILS.path}
            element={
              <PrivateRoute
                component={AsyncAdminTag}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.ADMIN_ROOT.path}
            element={
              <PrivateRoute
                component={AsyncAdminDashboard}
                permissions="admin"
                smallWindow={this.props.smallWindow}
                showToast={this.props.showToast}
              />
            }
          />

          <Route
            path={TalaeraRoutes.SIGN_OUT.path}
            element={
              <Route
                render={
                  <TalaeraDefaultBackground>
                    <SignOut />
                  </TalaeraDefaultBackground>
                }
              />
            }
          />

          <Route path={"*"} element={<UnauthRoutes showWrongLinkIfAuthenticated />} />
        </Routes>
      </ErrorBoundary>
    );
  }
}
